import React, { Suspense } from 'react'
import { Loading, TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { Breakpoint, ResidentNotifications, View } from '../../../components'
import { ContractModificationErrorHandler } from '../ContractModificationErrorHandler'
import { useContractPaths } from '../../../hooks/useContractPaths/useContractPaths'
import { useContractNotificationCategories } from '../hooks/useContractNotificationCategories'
import { AddTenantDataLoader } from './AddTenantDataLoader'
import { AddTenantForm } from './AddTenantForm'

export const AddTenantPage = () => {
  const { t } = useTranslation(['common', 'contractModification', 'titles'])
  const { terminateContractPath } = useContractPaths()
  const { contractNotificationCategories } = useContractNotificationCategories()

  return (
    <TitleController title={t('titles:addTenant')}>
      <View>
        <View.Header>
          <View.HeaderLink to={terminateContractPath}>
            {t('common:views.terminateContract')}
          </View.HeaderLink>

          <View.HeaderTitle>
            {t('contractModification:view.addTenantTitle')}
          </View.HeaderTitle>

          <Breakpoint show tablet phone>
            <ResidentNotifications
              categories={contractNotificationCategories}
            />
          </Breakpoint>
        </View.Header>
        <View.Sidebar>
          <Breakpoint show desktop>
            <ResidentNotifications
              categories={contractNotificationCategories}
            />
          </Breakpoint>
        </View.Sidebar>
        <View.Content>
          <Suspense fallback={<Loading variant="details" />}>
            <ContractModificationErrorHandler view="form">
              <AddTenantDataLoader>
                {(data) => <AddTenantForm {...data} />}
              </AddTenantDataLoader>
            </ContractModificationErrorHandler>
          </Suspense>
        </View.Content>
      </View>
    </TitleController>
  )
}
